import React from 'react';
import PropTypes from 'prop-types';

const { classNames } = Mobi2Go.helpers;

const Line2Input = ({
    label,
    show_specific_number,
    specific_number,
    specific_number_placeholder,
    specific_number_input_events,
    specific_number_ready_only,
    street_number,
    street_number_placeholder,
    street_number_input_events,
    street_number_read_only,
    street_name,
    street_name_placeholder,
    street_name_input_events,
    street_name_read_only,
}) => (
    <div
        data-street-group
        className="m2g-customer-address-line-2 m2g-customer-address-form-group"
    >
        <div
            data-street-label
            className="m2g-customer-address-form-group-label"
        >
            {label}
        </div>
        <div className="m2g-customer-address-form-group-controls m2g-form-element-group">
            {show_specific_number && (
                <input
                    data-specific-number
                    data-field="specific_number"
                    className="m2g-customer-address-specific-number-input m2g-input m2g-form-element--one-quarter-width m2g-form-element--right-join"
                    value={specific_number}
                    placeholder={specific_number_placeholder}
                    readOnly={specific_number_ready_only}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...specific_number_input_events}
                />
            )}
            <input
                data-street-number
                data-field="street_number"
                className={classNames(
                    'm2g-customer-address-street-number-input',
                    'm2g-input',
                    'm2g-form-element--one-quarter-width',
                    {
                        'm2g-form-element--center-join': show_specific_number,
                        'm2g-form-element--right-join': !show_specific_number,
                    }
                )}
                value={street_number}
                placeholder={street_number_placeholder}
                readOnly={street_number_read_only}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...street_number_input_events}
            />
            <input
                data-street-name
                data-field="street_name"
                className={classNames(
                    'm2g-customer-address-street-name-input',
                    'm2g-input',
                    'm2g-form-element--left-join',
                    {
                        'm2g-form-element--half-width': show_specific_number,
                        'm2g-form-element--three-quarter-width': !show_specific_number,
                    }
                )}
                value={street_name}
                placeholder={street_name_placeholder}
                readOnly={street_name_read_only}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...street_name_input_events}
            />
        </div>
    </div>
);

const input_events_shape = {
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
};

Line2Input.propTypes = {
    label: PropTypes.string.isRequired,
    show_specific_number: PropTypes.bool.isRequired,
    specific_number: PropTypes.string,
    specific_number_placeholder: PropTypes.string.isRequired,
    specific_number_input_events: PropTypes.shape(input_events_shape)
        .isRequired,
    specific_number_ready_only: PropTypes.bool.isRequired,
    street_number: PropTypes.string,
    street_number_placeholder: PropTypes.string.isRequired,
    street_number_input_events: PropTypes.shape(input_events_shape).isRequired,
    street_number_read_only: PropTypes.bool.isRequired,
    street_name: PropTypes.string,
    street_name_placeholder: PropTypes.string.isRequired,
    street_name_input_events: PropTypes.shape(input_events_shape).isRequired,
    street_name_read_only: PropTypes.bool.isRequired,
};

Line2Input.defaultProps = {
    specific_number: '',
    street_number: '',
    street_name: '',
};

export default Line2Input;
